var PriceItem = (function () {

    var $ = require('jquery');
    var self = {};

    self.init = function () {

        //  When the radio changes, update the price holder
        $('.price-item .radio input').on('change', function () {

            var $this = $(this);
            var priceNonRecurring = $this.parent().data('price-non-recurring');
            var priceSubscription = $this.parent().data('price-subscription');
            var $priceItem = $this.closest('.price-item');

            //  Change the prize
            $priceItem.find('[data-price-holder-non-recurring]').html(priceNonRecurring);
            $priceItem.find('[data-price-holder-subscription]').html(priceSubscription);

        });

    };

    return self;

}());

module.exports = PriceItem;
